import { Package, ShieldCheck } from "lucide-react"
import { useTranslation } from "react-i18next"

import { currentServiceLines } from "@/lib/contract-utils"
import { cn, formatAmount } from "@/lib/utils"
import type { LineDetails } from "@/types/contract"

const SERVICE_ICONS = {
  rack: Package,
  insurance: ShieldCheck,
} as const

export function ContractServiceChips({
  lineDetails,
  primaryLineId,
}: {
  lineDetails?: LineDetails[]
  primaryLineId?: number | null
}) {
  const { t } = useTranslation()

  const services = currentServiceLines(lineDetails, primaryLineId)

  if (services.length === 0) {
    return null
  }

  return (
    <div className="flex flex-wrap items-center gap-2 sm:mb-6 mb-4">
      {services.map(({ line, unpaidTotal }) => {
        const Icon = SERVICE_ICONS[line.kind]
        const hasDebt = unpaidTotal > 0

        return (
          <span
            key={line.id}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-medium",
              hasDebt ? "bg-payment-expired text-foreground" : "bg-input text-foreground",
            )}
          >
            <Icon className="size-4" aria-hidden />
            {t(`contracts.services.${line.kind}`)}
            {hasDebt ? t("contracts.services.debt", { amount: formatAmount(unpaidTotal) }) : null}
          </span>
        )
      })}
    </div>
  )
}
